import { useQuery, useMutation, keepPreviousData } from "@tanstack/react-query";
import qs from "qs";
import api from "@services/api";

async function fetchUserGroups(filters, page, pageSize) {
  const query = qs.stringify(
    { ...filters, page, page_size: pageSize },
    { arrayFormat: "indices", encodeValuesOnly: true }
  );

  const { data } = await api.get(`/user-group?${query}`);
  return data;
}

export function useUserGroupsQuery(filters, page, pageSize) {
  return useQuery({
    queryKey: ["system", "user-group", filters, page, pageSize],
    queryFn: () => fetchUserGroups(filters, page, pageSize),
    placeholderData: keepPreviousData
  });
}

export function useUserGroupQuery(id) {
  return useQuery({
    queryKey: ["system", "user-group", id],
    queryFn: async () => {
      const { data } = await api.get(`/user-group/${id}`);
      return data;
    },
    enabled: !!id
  });
}

export function useCreateUserGroupMutation() {
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.post(`/user-group`, payload);
      return data;
    }
  });
}

export function useSaveUserGroupMutation() {
  return useMutation({
    mutationFn: async ({ id, payload }) => {
      // backend route is POST /user-group/{userGroup}
      const { data } = await api.post(`/user-group/${id}`, payload);
      return data;
    }
  });
}

export function useDeleteUserGroupMutation() {
  return useMutation({
    mutationFn: async (id) => {
      const { data } = await api.delete(`/user-group/${id}`);
      return data;
    }
  });
}

export function usePermissionsListQuery() {
  return useQuery({
    queryKey: ["system", "user-group", "permissions"],
    queryFn: async () => {
      const { data } = await api.get(`/user-group/permissions`);
      // data = { permissions: [...] }
      return data;
    }
  });
}
